export class StorageUnit {
  constructor() {}

  manufacturer: string;
  usable_capacity: number;
  max_discharge_capacity: number;
}
